export const errorMessage = 'Something went wrong. Please try again.';
export const noDataMessage = 'No data. Something went wrong. Please try again.';
export const pageTitle = 'Transaction Details';
export const detailsTabLabel = 'Details';
export const eventDataTabLabel = 'Event Data';
